import {
  yesNoSchema,
  yesNoUI,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import content from '../../../utils/content.json';

/** @type {PageSchema} */
export default {
  uiSchema: {
    ...titleUI(content['household-remarriage-title']),
    remarriedAfterVeteralDeath: yesNoUI({
      title: content['household-remarriage-question'],
    }),
  },
  schema: {
    type: 'object',
    required: ['remarriedAfterVeteralDeath'],
    properties: {
      remarriedAfterVeteralDeath: yesNoSchema,
    },
  },
};
